
import React, { useState, useEffect } from 'react'
import { getOrdersCalculations } from '../../../actions/orderAction'

export default function OrderStats() {
    const [orders, setOrders] = useState([
        {
            count: 0,
            pendingOrders: 0,
            acceptedOrders: 0,
            startedOrders: 0,
            completedOrders: 0,
            rejectedOrders: 0,
        }
    ])
    const [countries] = useState(['USA', 'Canada'])
    const [loading, setLoading] = useState(false)
    const fetchOrders = async () => {
        try {
            const ors = await Promise.all(countries.map(country => getOrdersCalculations(country)));
            setOrders(ors);
            setLoading(true);
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        fetchOrders();
    }, [])

    return (
        <div className="ibox">
            <div className="ibox-title" style={{ minHeight: 84 }}>
                <h5>Order Statistics</h5>
                <div className='ibox-tools'>
                    <div className='custom-ibox-tools'>
                        <span className='text-uppercase'>Total Orders</span>
                    </div>
                    {
                        loading && orders.map((order, i) => (
                            <div className='custom-ibox-tools' key={i}>
                                <span>{countries[i]}:  </span>
                                <span>{order.count}</span>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="card card-dashboard-table table-responsive">
                <table className="table table-bordered ">
                    <thead>
                        <tr>
                            <th>Country</th>
                            <th className='bg-primary'>Accepted</th>
                            <th className='bg-warning' >Pending</th>
                            <th className='bg-info' >Running</th>
                            <th className='bg-success' >Completed</th>
                            <th className='bg-danger' >Rejected</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading && orders.map((country, i) => (
                                <tr key={i}>
                                    <td><a href="#" className='small'>{countries[i]}</a></td>
                                    <td className='small'>{country.acceptedOrders}</td>
                                    <td className='small'>{country.pendingOrders}</td>
                                    <td className='small'>{country.startedOrders}</td>
                                    <td className='small'>{country.completedOrders}</td>
                                    <td className='small'>{country.rejectedOrders}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
